import clsx from "clsx";
import Link from "next/link";
import Image from "next/image";
import { TagS } from "@/components/molecules/TagS";
import { useBudouX } from "@/hooks/useBudouX";

export const ProjectCard = ({ className, title, src, href, id, tag }) => {
  const { parse } = useBudouX();
  return (
    <>
      <Link href={href}>
        <div
          className={clsx(
            className,
            "group w-full cursor-pointer border border-solid border-bdc-light hover:border-hov/30 md:border-bdc-light"
          )}
        >
          <figure className="relative aspect-1.91/1 group-hover:opacity-80">
            <Image
              src={src}
              alt={title}
              quality={80}
              layout="fill"
              objectFit="cover"
            />
          </figure>
          <div className="space-y-2 py-2 2xs:px-2 xs:px-3 md:space-y-3 md:py-4 md:px-6">
            <h4 className="font-bold leading-none text-icn fluid-text-[12px,14px]">
              Project No.{id}
            </h4>
            <h3 className="font-bold text-txt-base fluid-text-[12px,18px] group-hover:text-hov 2xs:line-clamp-2 xs:line-clamp-3">
              {title}
            </h3>
            <div className="flex flex-wrap justify-start gap-2 2xs:gap-1 xs:gap-2 md:justify-end">
              {tag.map((tag) => (
                <TagS key={id}>{tag}</TagS>
              ))}
            </div>
          </div>
        </div>
      </Link>
    </>
  );
};
